<template>
  <section class="f-36">
    <div class="alive_content f-select-center" v-ia>
      <div class="alive_card">
        <div class="title">不惧临时任务，双小窗随心切</div>
        <div class="sub_title">新小窗打开时，旧小窗将收起，点击可切换</div>
        <m-video
          ref="video1"
          muted
          loop
          playsinline
          webkit-playsinline
          disablepictureinpicture
          src="@/v2/auto/assets/video/36/0.mp4"
        />
        <div class="bottom_replay">
          <replay class="replay" @click="replayVideo($refs.video1)" />
        </div>
      </div>
      <div class="alive_card">
        <div class="title">小窗降噪，应用内自动贴边</div>
        <div class="sub_title">
          退出应用后自动展开恢复小窗，也可手动点击展开
        </div>
        <m-video
          ref="video2"
          muted
          loop
          playsinline
          webkit-playsinline
          disablepictureinpicture
          src="@/v2/auto/assets/video/36/1.mp4"
        />
        <div class="bottom_replay">
          <replay class="replay" @click="replayVideo($refs.video2)" />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { videoPlayByVisibleArea, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'
export default {
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    const { video1, video2 } = this.$refs
    video1 && videoPlayByVisibleArea(video1)
    video2 && videoPlayByVisibleArea(video2)
  },
  methods: { replayVideo },
}
</script>
<style lang="less" scoped>
.f-36 {
  width: 100%;
  position: sticky;
  z-index: 79;
  background: #ffffff;
  height: 960px;
  display: flex;
  justify-content: center;
  align-items: center;
  .alive_content {
    display: flex;
    gap: 16px;
    .alive_card {
      flex: 1;
      position: relative;
      border-radius: 24px;
      overflow: hidden;
      background-color: #f4f4f5;
      .title {
        margin-top: 8%;
        margin-left: 8%;
        font-size: 24px;
        font-weight: 600;
      }
      .sub_title {
        margin-top: 15px;
        margin-left: 8%;
        font-size: 16px;
        color: #00000080;
      }
      video {
        position: absolute;
        border-top-left-radius: 24px;
        width: 92%;
        bottom: 0;
        right: 0;
      }
      .bottom_replay {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 100px;
        background: linear-gradient(to bottom, #f2f6fa00, #f2f6fa);
        .replay {
          position: absolute;
          z-index: 2;
          bottom: 20px;
          right: 20px;
          color: #3b82fc;
        }
      }
    }
  }
}
</style>
